import { ChevronUpIcon } from '@primer/octicons-react';
import React, { useEffect, useState } from 'react';
import { AnchorLink } from '@/styles/commonStyles';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';
import { StyledContainer, StyledFab, StyledTopButton } from './styles';

export default function Footer() {
  const [showScrollButton, setShowScrollButton] = useState(window.scrollY > 10);
  const currentYear = new Date().getFullYear();
  const {
    externalLinks: { codersRank },
  } = GLOBAL_CONSTANTS;

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop } = document.body;
      if (scrollTop > 10) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };
    document.body.addEventListener('scroll', handleScroll);
    return () => {
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScrollTop = () => document.body.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  return (
    <StyledContainer>
      <p className="text-center">
        <AnchorLink href={codersRank}>Papu Kumar</AnchorLink> &copy; 2021 - {currentYear}
      </p>
      {showScrollButton ? (
        <StyledTopButton>
          <StyledFab size="small" aria-label="scroll top" onClick={handleScrollTop} color="secondary">
            <ChevronUpIcon />
          </StyledFab>
        </StyledTopButton>
      ) : null}
    </StyledContainer>
  );
}
